import { render, staticRenderFns } from "./customerAdmin.vue?vue&type=template&id=3e5aa014&"
import script from "./customerAdmin.vue?vue&type=script&lang=js&"
export * from "./customerAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports